import { Condition, ConditionType, PreorderCondition } from '@interfaces'

export const isStopLossOrder = (
  conditionInfo: PreorderCondition | Condition,
): boolean => {
  return conditionInfo?.stopType === ConditionType?.STOP_LOSS
}
